<template>
  <div id="genero-plano" class="mt-3">
    <h1 class="text-center md-display-1 text-dark mt-5 mb-5">Para <span class="text-primary font-weight-bold">você</span> ou para o seu <span class="text-primary font-weight-bold">negócio</span>?</h1>
    <div class="container-btn-planos flex-lg-row flex-column mt-2">
      <router-link tag="div" to="planos/residencial" class="box-join end mr-0 mb-4 mb-lg-0 mr-lg-5">
        <btn-consulte class="mr-4 d-none d-lg-flex"></btn-consulte>
        <div class="d-flex flex-column align-items-center">
          <img class="image-plano pointer"
               src="../assets/icon/home_ico_planos.png"
               alt="Casa">
          <h2 class="text-primary">Residencial</h2>
        </div>
      </router-link>
      <span class="divider-red d-none d-lg-flex"></span>
      <router-link tag="div" to="planos/empresarial" class="box-join ml-0 ml-lg-5">
        <div class="d-flex flex-column align-items-center">
          <img class="image-plano pointer"
               src="../assets/icon/build_ico_planos.png"
               alt="Prédio">
          <h2 class="text-primary">Empresarial</h2>
        </div>
        <btn-consulte class="ml-4 d-none d-lg-flex" :flip="true" ></btn-consulte>
      </router-link>
    </div>
  </div>
</template>

<script>
  import BtnConsulte from '../components/BtnConsulte';

  export default {
    name: 'GeneroPlano',
    components: { BtnConsulte }
  }
</script>

<style scoped lang="scss">
  #genero-plano {
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    .container-btn-planos {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }

  .image-plano {
    height: 270px;
  }

  .divider-red {
    display: block;
    width: 6px;
    background-color: #cc0000;
    height: 140px;
  }

  .box-join {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    &.end {
      justify-content: flex-end;
    }
  }
</style>
